/**
 * NEX Tutorial Manifest
 * ---------------------
 * Videos are managed at /admin/tutorials via the object-storage-backed
 * uploader. This module fetches the live manifest from the backend on
 * demand, caches it in memory, and exposes seen/opt-out helpers.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OPT_OUT_KEY = "nex_tutorial_optout";
const SEEN_KEY_FN = (k) => `nex_tutorial_seen__${k}`;

const DEFAULT_TITLES = {
  "main.overview":            "NEX · Platform Welcome",
  "field_services.overview":  "Field Services · Industry Overview",
  "legal_finance.overview":   "Legal & Finance · Industry Overview",
  "health_wellness.overview": "Health & Wellness · Industry Overview",
};

let _manifest = null;
let _inflight = null;

async function loadManifest() {
  if (_manifest) return _manifest;
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API}/tutorials`)
    .then(r => { _manifest = r.data.items || {}; return _manifest; })
    .catch(() => { _manifest = {}; return _manifest; })
    .finally(() => { _inflight = null; });
  return _inflight;
}

/** Async: returns the live entry ({url,title,size,...}) for a key, or null. */
export async function fetchTutorial(key) {
  const m = await loadManifest();
  return m[key] || null;
}

/** Async: is the tutorial ready to render for this user? */
export async function isTutorialAvailable(key) {
  if (localStorage.getItem(OPT_OUT_KEY) === "1") return false;
  if (localStorage.getItem(SEEN_KEY_FN(key)) === "1") return false;
  const entry = await fetchTutorial(key);
  return !!(entry && entry.url);
}

export function getTitle(key) { return DEFAULT_TITLES[key] || key; }
export function markTutorialSeen(key) { localStorage.setItem(SEEN_KEY_FN(key), "1"); }
export function optOutAllTutorials()  { localStorage.setItem(OPT_OUT_KEY, "1"); }
export function resetAllTutorials() {
  localStorage.removeItem(OPT_OUT_KEY);
  localStorage.removeItem(SEEN_KEY_FN("main.overview"));
  const industries = ["field_services", "legal_finance", "health_wellness"];
  for (const ind of industries) {
    localStorage.removeItem(SEEN_KEY_FN(`${ind}.overview`));
    for (let n = 1; n <= 10; n++) {
      localStorage.removeItem(SEEN_KEY_FN(`${ind}.step_${n}`));
    }
  }
  _manifest = null;
}
